import React from 'react';
import { ScheduleItem } from '@app-types';
import { UserPermissions } from '@contexts/AuthContext';
import { canEditRoles, RoleAssignmentButton } from './MultiRoleCell';
import AssessorName from './AssessorName';
import styles from './SchedulerTableCells.module.css';

const AssessorCell: React.FC<{
  scheduleItem: ScheduleItem;
  permissions: UserPermissions;
  onAssignRole: (item: ScheduleItem, contractId: number, role: 'assessor') => void;
  isChildRow?: boolean;
}> = ({ scheduleItem, permissions, onAssignRole, isChildRow }) => {
  const hasAssessor = !!(scheduleItem.assessor && scheduleItem.assessor.id > 0);

  return (
    <div className={styles.assessorCell}>
      <div className={styles.roleAssignment}>
        <span className={styles.roleName}>
          <AssessorName isChildRow={isChildRow} hasAssessor={hasAssessor} assessorName={scheduleItem.assessor?.name} />
        </span>
        {permissions.canAccessScheduler && canEditRoles(scheduleItem, 'assessor') && !isChildRow && (
          <RoleAssignmentButton
            hasAssignees={hasAssessor}
            onClick={() => onAssignRole(scheduleItem, scheduleItem.contracts[0].id, 'assessor')}
            dataTestId="role-assign-btn-assessor"
          />
        )}
      </div>
    </div>
  );
};

export default AssessorCell;
